import Immutable from 'immutable';

// constants
import { APPOINTMENT_CREATE } from '../constants/appointmentTypes';

import { BOOKED_APPOINTMENT_CLEAR } from '../constants/bookedAppointmentTypes';

// lib
import httpReducer from '../lib/httpReducer';

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case APPOINTMENT_CREATE:       return httpReducer(state, action);
    case BOOKED_APPOINTMENT_CLEAR: return Immutable.Map();
    default:                       return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/bookedAppointment.js